import { Component, OnInit } from '@angular/core';
import { AccountService } from './account.service';
import { LoginService } from '../../login/login.service';
import { LanguageService } from '../../language.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
// import { error } from 'util';

declare const jQuery: any;
declare var $: any;
declare var swal: any;
declare var unescape: any;
declare var toastr: any;

@Component({
  selector: 'account',
  templateUrl: './account.component.html',
  styleUrls: ['../dispatcher.component.css', './account.component.css']
})
export class AccountComponent implements OnInit {
  online$: Observable<boolean>;
  myacc: any;

  current_time: any;
  current_time_var: any;
  email: any;
  first_name: any;
  last_name: any;
  phone: any;
  show_mail = false;
  show_name = false;
  show_phone = false;
  phone_bool = false;
  signup_otpcode: any;
  signup_number: any;
  first_name_change: any;
  email_change: any;
  current_password: any;
  timer_i: any;
  current_password_block = false;
  change_password_block = true;
  counter_bool = false;
  change_password: any;
  current_renter_password: any;
  loader_show = false;
  file: any;
  photo: any;
  update_photo: any;
  window: any = window;
  errMsg: any;
  userId: any;
  checkphoneerr: any;
  otpsenderr: any;
  otpverifyerr: any;
  passchange: any;
  mailchange: any;
  namechange: any;
  phoneForm: any;
  passwordForm: any;
  countryCode: any;
  constructor(private _router: Router, private _AccountService: AccountService, private _loginService: LoginService, private languageService: LanguageService) {

  }

  // Update Profile
  updateProfile(val) {
    switch (val) {
      case 1:
        let name = '';
        let email = '';
        let oldPassword = '';
        let password = '';
        let mobile = '';
        let profile = '';
        let obj = {};

        if (this.show_name == true) {
          $('.account_loading_parent').show();
          name = this.first_name_change;
          email = password = mobile = profile = '';
          obj = { 'firstName': name };
          this.loader_show = true;
          this._AccountService.changeFirstName(
            obj
          ).subscribe(() => {
            $('.account_loading_parent').hide();
            this.first_name = this.first_name_change;
            this.loader_show = false;
            console.log();
            swal(this.myacc.detailsUpdated, this.myacc.profUpSucc, this.myacc.success);
            $('#confirmmail_phone').modal('hide');
            $('#confirmmail_form').show();
            $('.confirmmail_head').show();
            $('#confirmmail_form').animate({ left: '0px', opacity: 1 }, 400);
            $('.wrap').hide();
            $('.module.inp.test input').val('');
            $('.modal').modal('hide');
            this.phone_bool = false;
            // this.profile_me();
          }
            , (err) => {
              console.log('errMsg', err.status);
              if (err.status > 401 && err.status < 500) {
                err.status = 420; // merging all the status codes to one status code 420
              }
              if (err.status > 499) {
                err.status = 520; // merging all the status codes to one status code 420
              }
              switch (err.status) {
                case 0:
                  $('.account_loading_parent').hide();
                  this.errMsg = err.error;
                  toastr['error'](this.errMsg.message);
                  break;
                case 520:
                  $('.account_loading_parent').hide();
                  this.errMsg = err.error;
                  toastr['error'](this.errMsg.message);
                  break;
                case 401:
                  this._router.navigate(['login']);
                  break;
                case 400:
                  $('.account_loading_parent').hide();
                  this.errMsg = err.error;
                  toastr['error'](this.errMsg.message);
                  break;
                case 420:
                  setTimeout(() => {
                    this.namechange = '';
                  }, 5000);
                  this.namechange = err.error;
                  this.namechange = this.namechange.message;
                  $('.account_loading_parent').hide();
                  break;
              }
            }
          );
        }
        else if (this.show_mail == true) {
          $('.account_loading_parent').show();
          email = this.email_change;
          name = password = mobile = profile = '';
          obj = { 'email': email };
          this.loader_show = true;
          this._AccountService.changeEmail(
            obj
          ).subscribe(() => {
            $('.account_loading_parent').hide();
            this.email = this.email_change;
            this.loader_show = false;
            console.log();
            swal(this.myacc.detailsUpdated, this.myacc.profUpSucc, this.myacc.success);
            $('#confirmmail_phone').modal('hide');
            $('#confirmmail_form').show();
            $('.confirmmail_head').show();
            $('#confirmmail_form').animate({ left: '0px', opacity: 1 }, 400);
            $('.wrap').hide();
            $('.module.inp.test input').val('');
            $('.modal').modal('hide');
            this.phone_bool = false;
            // this.profile_me();
          }
            , (err) => {
              console.log('errMsg', err.status);
              if (err.status > 401 && err.status < 500) {
                err.status = 420; // merging all the status codes to one status code 420
              }
              if (err.status > 499) {
                err.status = 520; // merging all the status codes to one status code 420
              }
              switch (err.status) {
                case 0:
                  $('.account_loading_parent').hide();
                  this.errMsg = err.error;
                  toastr['error'](this.errMsg.message);
                  break;
                case 520:
                  $('.account_loading_parent').hide();
                  this.errMsg = err.error;
                  toastr['error'](this.errMsg.message);
                  break;
                case 401:
                  this._router.navigate(['login']);
                  break;
                case 400:
                  $('.account_loading_parent').hide();
                  this.errMsg = err.error;
                  toastr['error'](this.errMsg.message);
                  break;
                case 420:
                  setTimeout(() => {
                    this.mailchange = '';
                  }, 5000);
                  this.mailchange = err.error;
                  this.mailchange = this.mailchange.message;
                  $('.account_loading_parent').hide();
                  break;
              }
            }
          );
        }
        else if (this.change_password_block == true) {
          $('.account_loading_parent').show();
          oldPassword = this.current_password;
          password = this.current_renter_password;
          name = email = mobile = profile = '';
          obj = {
            'newPassword': password,
            'oldPassword': oldPassword
          };
          this.loader_show = true;
          this._AccountService.changePassword(
            obj
          ).subscribe((res) => {
            $('.account_loading_parent').hide();
            this.loader_show = false;
            console.log();
            swal(this.myacc.passContent, res['message'], this.myacc.success);
            $('#confirmmail_phone').modal('hide');
            $('#confirmmail_form').show();
            $('.confirmmail_head').show();
            $('#confirmmail_form').animate({ left: '0px', opacity: 1 }, 400);
            $('.wrap').hide();
            $('.module.inp.test input').val('');
            $('.modal').modal('hide');
            this.phone_bool = false;
            // this.profile_me();
          }
            , (err) => {
              console.log('errMsg', err.status);
              if (err.status > 401 && err.status < 500) {
                err.status = 420; // merging all the status codes to one status code 420
              }
              if (err.status > 499) {
                err.status = 520; // merging all the status codes to one status code 420
              }
              switch (err.status) {
                case 0:
                  $('.account_loading_parent').hide();
                  this.loader_show = false;
                  this.errMsg = err.error;
                  toastr['error'](this.errMsg.message);
                  break;
                case 520:
                  $('.account_loading_parent').hide();
                  this.loader_show = false;
                  this.errMsg = err.error;
                  toastr['error'](this.errMsg.message);
                  break;
                case 401:
                  this._router.navigate(['login']);
                  break;
                case 400:
                  $('.account_loading_parent').hide();
                  this.loader_show = false;
                  this.errMsg = err.error;
                  toastr['error'](this.errMsg.message);
                  break;
                case 420:
                  setTimeout(() => {
                    this.passchange = '';
                  }, 5000);
                  this.passchange = err.error;
                  this.passchange = this.passchange.message;
                  $('.account_loading_parent').hide();
                  break;
              }
            }
          );
        }
        break;
      case 0:
        // $('.account_loading_parent').show();
        const countryData = $('#changePhone').intlTelInput('getSelectedCountryData').dialCode;
        this.signup_otpcode = $('#1').val() + $('#2').val() + $('#3').val() + $('#4').val();
        // obj = {

        // }
        $('#loader').show();
        this._AccountService.signupotp({
          code: this.signup_otpcode,
          userId: this.userId,
          trigger: 3
        }).subscribe((res) => {
          $('.account_loading_parent').hide();
          this.loader_show = false;
          this.phone = '+' + countryData + ' ' + this.signup_number;
          console.log();
          swal(this.myacc.detailsUpdated, res['message'], this.myacc.success);
          $('#confirmmail_phone').modal('hide');
          $('#confirmmail_form').hide();
          $('.confirmmail_head').hide();
          $('#confirmmail_form').animate({ left: '0px', opacity: 1 }, 400);
          $('.wrap').show();
          $('.module.inp.test input').val('');
          $('.modal').modal('hide');
          this.phone_bool = false;
          // this.profile_me();
        }
          , (err) => {
            console.log('errMsg', err);
            if (err.status > 401 && err.status < 500) {
              err.status = 420; // merging all the status codes to one status code 420
            }
            if (err.status > 499) {
              err.status = 520; // merging all the status codes to one status code 420
            }
            switch (err.status) {
              case 0:
                $('#loader').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
              case 520:
                $('#loader').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
                break;
              case 401:
                this._router.navigate(['login']);
                break;
              case 400:
                $('#loader').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
                break;
              case 420:
                setTimeout(() => {
                  this.otpverifyerr = '';
                }, 5000);
                this.otpverifyerr = err.error;
                this.otpverifyerr = this.otpverifyerr.message;
                $('#loader').hide();
                break;
            }
          }
        );
        break;
      case 2:
        $('.account_loading_parent').show();
        obj = { 'profilePic': this.update_photo };
        this.loader_show = true;
        this._AccountService.changeFirstName(
          obj
        ).subscribe((res) => {
          $('.account_loading_parent').hide();
          this.loader_show = false;
          console.log();
          swal(this.myacc.detailsUpdated, res['message'], this.myacc.success);
          $('#confirmmail_phone').modal('hide');
          $('#confirmmail_form').show();
          $('.confirmmail_head').show();
          $('#confirmmail_form').animate({ left: '0px', opacity: 1 }, 400);
          $('.wrap').hide();
          $('.module.inp.test input').val('');
          $('.modal').modal('hide');
          this.phone_bool = false;
          // this.profile_me();
        }
          , (err) => {
            console.log('errMsg', err.status);
            if (err.status > 401 && err.status < 500) {
              err.status = 420; // merging all the status codes to one status code 420
            }
            if (err.status > 499) {
              err.status = 520; // merging all the status codes to one status code 420
            }
            switch (err.status) {
              case 0:
                $('.account_loading_parent').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
                break;
              case 520:
                $('.account_loading_parent').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
                break;
              case 401:
                this._router.navigate(['login']);
                break;
              case 400:
                $('.account_loading_parent').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
                break;
              case 420:
                $('.account_loading_parent').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
                break;
            }
          }
        );
        break;
    }
  }

  openchange_modal(input_field) {
    if (input_field == 0) {
      this.show_mail = false;
      this.show_name = true;
      this.show_phone = false;
      $('#change_profile_modal').modal({ backdrop: 'static', keyboard: false });
    }
    else if (input_field == 1) {
      this.show_mail = false;
      this.show_name = false;
      this.show_phone = true;
      $('#confirmmail_phone').modal('show');
      // $('.wrap').hide();
      // $('#confirmmail_form').show();
    }
    else if (input_field == 2) {
      this.show_mail = true;
      this.show_name = false;
      this.show_phone = false;
      $('#change_profile_modal').modal({ backdrop: 'static', keyboard: false });
    }

  }
  openchange_pass() {
    this.show_mail = false;
    this.show_name = false;
    this.show_phone = false;
    $('#change_password_modal').modal('show');
  }
  changeBool() {
    this.phone_bool = false;
    console.log('changed');
  }

  changeOtpScreen() {
    $('#confirmmail_form').animate({ left: '-645px', opacity: 0 }, 400);
    $('.confirmmail_head').hide();
    setTimeout(function () {
      $('#confirmmail_form').hide();
      $('.wrap').show();
      $('#1').focus();
    }, 405);
    this.timer_i = 60;
    this.counter_bool = false;
    this.onTimer();
    $('#loader').hide();
  }

  // Phone Validation
  check_phone() {
    const countryData = $('#changePhone').intlTelInput('getSelectedCountryData').dialCode;
    this._AccountService.checkPhone({
      countryCode: '+' + countryData,
      phone: this.signup_number
    }).subscribe(() => {
      $('.account_loading_parent').hide();
      $('.phone_validations').addClass('has-success');
      $('.phone_validations').removeClass('has-error');
      $('.loader_phone').hide();
      this.phone_bool = true;
      // this.changeOtpScreen();
      this.otpsend();
    }
      , (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
          case 520:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 401:
            this._router.navigate(['login']);
            break;
          case 400:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 420:
            setTimeout(() => {
              this.checkphoneerr = '';
            }, 5000);
            this.checkphoneerr = err.error;
            this.checkphoneerr = this.checkphoneerr.message;
            $('#loader').hide();
            break;
        }
      }
    );
  }

  backsend() {
    // $(".module.inp.test input").val('');
    $('#confirmmail_phone input').val('');
    $('.wrap').animate({ left: '-625px', opacity: 0 }, 400);
    $('#confirmmail_form').animate({ left: '0px', opacity: 1 }, 400);
    setTimeout(function () {
      $('.confirmmail_head').show();
      $('#confirmmail_form').show();
      $('.wrap').hide();
      $('.wrap').animate({ left: '0px', opacity: 1 });
    }, 405);
  }

  // OTP Resend
  otpresend() {
    $('.account_loading_parent').show();
    this._AccountService.signupotpresend({
      userId: this.userId,
      trigger: 3
    }).subscribe(() => {
      $('#confirmmail_form').animate({ left: '-645px', opacity: 0 }, 400);
      $('.confirmmail_head').hide();
      setTimeout(function () {
        $('.form').hide();
        $('.wrap').show();
        $('#1').focus();
      }, 405);
      this.timer_i = 60;
      this.counter_bool = false;
      this.onTimer();
      $('.account_loading_parent').hide();
    }
      , (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 520:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 401:
            this._router.navigate(['login']);
            break;
          case 400:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 420:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
        }
      }
    );
  }

  errphonechange: any;
  // OTP Verify
  otpsend() {
    $('.account_loading_parent').show();
    const countryData = $('#changePhone').intlTelInput('getSelectedCountryData').dialCode;
    this.countryCode = '+' + countryData;
    this.loader_show = true;
    this._AccountService.changePhoneNum({
      countryCode: '+' + countryData,
      phone: this.signup_number
    }).subscribe(() => {
      $('.loader_phone').hide();
      $('.account_loading_parent').hide();
      $('#confirmmail_form').animate({ left: '-645px', opacity: 0 }, 400);
      $('.confirmmail_head').hide();
      setTimeout(function () {
        $('#confirmmail_form').hide();
        $('.wrap').show();
        $('#1').focus();
      }, 405);
      this.timer_i = 60;
      this.counter_bool = false;
      this.onTimer();
      // this.updateProfile(0);
    }
      , (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $('.account_loading_parent').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 520:
            $('.account_loading_parent').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 401:
            this._router.navigate(['login']);
            break;
          case 400:
            $('.account_loading_parent').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 420:
            $('.account_loading_parent').hide();
            this.errphonechange = err.error;
            console.log(this.errphonechange.message);
            swal('ERROR', this.errphonechange.message);
            this.errphonechange = this.errphonechange.message;
            break;
        }
      }
    );
  }

  // OTP Send
  verify_otp() {
    $('.account_loading_parent').show();
    this.signup_otpcode = $('#1').val() + $('#2').val() + $('#3').val() + $('#4').val();
    this._loginService.verifyotp({
      code: this.signup_otpcode,
      userId: this.userId,
    }).subscribe(() => {
      $('.account_loading_parent').hide();
      this.phone = this.signup_number;
      this.updateProfile(0);
      $('#confirmmail_form').hide();
      $('.wrap').hide();
    }
      , (err) => {
        console.log('errMsg', err);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
          case 520:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 401:
            this._router.navigate(['login']);
            break;
          case 400:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 420:
            setTimeout(() => {
              this.otpsenderr = '';
            }, 5000);
            this.otpsenderr = err.error;
            this.otpsenderr = this.otpsenderr.message;
            $('#loader').hide();
            break;
        }
      }
    );
  }

  onTimer() {
    const mycounter_fun = setInterval(() => {
      this.timer_i--;
      console.log('timerrunning');
      if (this.timer_i < 0) {
        $('#mycounter').text('');
        this.counter_bool = true;
        clearInterval(mycounter_fun);
      }
      else {
        $('#mycounter').text('Resend after ' + this.timer_i + ' secs');
      }
    }, 1000);
  }

  profile_me() {
    $('.account_loading_parent').show();
    this._AccountService.getProfile({
    }).subscribe((res: any) => {
      $('.account_loading_parent').hide();
      console.log(this.myacc.profile, res.data);
      this.first_name = res.data.firstName;
      this.email = res.data.email;
      this.phone = res.data.phone;
      this.email_change = res.data.email;
      this.first_name_change = res.data.firstName;
      if (res.data.profilePic != '') {
        this.photo = res.data.profilePic;
      }
      else {
        this.photo = '../../assets/img/image_upload.png';
      }
    }
      , (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 520:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 401:
            this._router.navigate(['login']);
            break;
          case 400:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 420:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
        }
      }
    );
  }

  checkcurrentPassword() {
    $('.account_loading_parent').show();
    this.loader_show = true;
    $('.password_error').empty();
    this._AccountService.checkpassword({
      password: this.current_password,
    }).subscribe((res: any) => {
      $('.account_loading_parent').hide();
      this.loader_show = false;
      console.log('currentpass', res);
      this.current_password_block = true;
      this.change_password_block = false;
    }
      , (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
          case 520:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 401:
            this._router.navigate(['login']);
            break;
          case 400:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 420:
            $('#loader').hide();
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
        }
      }
    );
  }
  remove_error() {
    $('.password_error').empty();
  }
  imgsrc_acc(id) {
    $('#input_upload' + id).trigger('click');
  }
  uploadImg_acc(fileInput: any, id) {
    this.loader_show = true;
    const input = fileInput.srcElement;
    if (input.files && input.files[0]) {
      this._AccountService.uploadImage(fileInput.target.files[0]).subscribe(
        (data: any) => {
          console.log(data);
          const imageUrl = data.data.url;
          this._AccountService.updateProfileImage({ profilePic: imageUrl }).subscribe(
            data => {
              console.log(data);
            },
            error => {
              console.log(error);
            }
          );
        },
        error => {
          console.log(error);
        }
      );
      const reader = new FileReader();
      reader.onload = (e: any) => {
        $('#upload' + id).attr('src', e.target.result);
        $('.delete_photo' + id).show();
        $('.show_upload' + id).show();

      };
      reader.readAsDataURL(input.files[0]);
    }
    console.log(fileInput);
    const compose = fileInput.target.files[0];
    const resizeImage = (settings: { maxSize, file }) => {           // resizesing image function
      const file = settings.file;
      const maxSize = settings.maxSize;
      const reader = new FileReader();
      const image = new Image();
      const canvas = document.createElement('canvas');
      const dataURItoBlob = (dataURI: string) => {
        const bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
          atob(dataURI.split(',')[1]) :
          unescape(dataURI.split(',')[1]);
        const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const max = bytes.length;
        const ia = new Uint8Array(max);
        for (let i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
        return new Blob([ia], { type: mime });
      };
      const resize = () => {
        let width = image.width;
        let height = image.height;

        if (width > height) {
          if (width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
          }
        }

        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(image, 0, 0, width, height);
        const dataUrl = canvas.toDataURL('image/png');
        return dataURItoBlob(dataUrl);
      };

      return new Promise((ok, no) => {
        if (!file.type.match(/image.*/)) {
          no(new Error('Not an image'));
          return;
        }

        reader.onload = (readerEvent: any) => {
          image.onload = () => ok(resize());
          image.src = readerEvent.target.result;
        };
        reader.readAsDataURL(file);
      });
    };

    resizeImage({                                            // resize image call
      file: compose,
      maxSize: 200
    }).then((resizedImage: any) => {
      console.log(this.myacc.resizedImage);
      console.log(resizedImage);
      function getRandomInt(min, max) {
        return 'webcustomer' + Math.floor(Math.random() * (max - min + 1)) + min;      // pushiing to this.file array
      }
      // this.updatephoto(img);
      $('.account_loading_parent').hide();
      $('#loader').hide();
      // this.updateProfile(2);
    }).catch(function (err) {
      console.error(err);
    });
  }
  updatephoto(fileInput) {
    console.log(fileInput);
    $('.account_loading_parent').show();
    // this._AccountService.changeProfileImage(fileInput).subscribe(
    //   (data: any) => {
    //     console.log(data);
    //     $('.account_loading_parent').hide();
    //     $('#loader').hide();
    //     this.updateProfile(2);

    //   },
    //   error => {
    //     console.log(error);
    //   }
    // )
    // this.AWSService.config.accessKeyId = myGlobals.awsid;
    // this.AWSService.config.secretAccessKey = myGlobals.awskey;
    // var bucket = new this.AWSService.S3({ params: { Bucket: myGlobals.awsbucket } });
    // var params = { Body: fileInput, Key: fileInput.name };
    // bucket.upload(params, (err, data) => {
    // $('.account_loading_parent').hide();
    // $('#loader').hide();
    // console.log(data);
    // this.update_photo = data.Location;
    // this.updateProfile(2);
    // });
  }
  ngOnInit() {
    this.profile_me();
    this.myacc = this.languageService.my_account;
    this.userId = sessionStorage.getItem('sid');
    // this.first_name = this.first_name;
    // this.email = this.email;
    // this.phone = this.phone;
    // if(this._cookie.getProfile('profilePic')){
    // this.photo = this._cookie.getProfile('profilePic');
    // }
    // else{
    // this.photo = "../../assets/img/image_upload.png";
    // }
    this.first_name_change = this.first_name;
    this.email_change = this.email;
    $('.booking_buutns').hide();

    // Toaseter
    toastr.options = {
      'closeButton': true,
      'debug': false,
      'newestOnTop': true,
      'progressBar': true,
      'positionClass': 'toast-top-right',
      'preventDuplicates': true,
      'showDuration': '300',
      'hideDuration': '1000',
      'timeOut': '3000',
      'extendedTimeOut': '1000',
      'showEasing': 'swing',
      'hideEasing': 'linear',
      'showMethod': 'fadeIn',
      'hideMethod': 'fadeOut'
    };


    $('#update_form').validate({
      rules: {
        name: {
          minlength: 3,
          required: true
        },
        email: {
          email: true,
          required: true
        },
      },
      highlight: function (element) {
        $(element).closest('.form-group').removeClass('has-success').addClass('has-error');
      },
      unhighlight: function (element) {
        $(element).closest('.form-group').removeClass('has-error').addClass('has-success');
      },
      submitHandler: () => {
        this.updateProfile(1);
      }
    });

    this.passwordForm = $('#update_password').validate({
      rules: {
        currentpassword: {
          minlength: 3,
          required: true
        },
        changepassword: {
          minlength: 3,
          required: true
        },
        reenterpassword: {
          required: true,
          equalTo: '#change_pass2',
        },
      },
      highlight: function (element) {
        $(element).closest('.form-group').removeClass('has-success').addClass('has-error');
      },
      unhighlight: function (element) {
        $(element).closest('.form-group').removeClass('has-error').addClass('has-success');
      },
      submitHandler: () => {
        if (this.current_password_block) {
          // this.checkcurrentPassword();
          // this.updateProfile(1);
          // alert("if part");
        }
        else {
          this.updateProfile(1);
        }
      }
    });

    this.phoneForm = $('#confirmmail_form').validate({
      rules: {
        changePhone: {
          uniqueUserName: true,
          required: true
        }
      },
      success: () => {
        // if ($(element).closest('.form-group').hasClass('phone_validations') && this.phone_bool == false) {
        //   $(".loader_phone").show();
        //   // this.check_phone();
        // }
      },
      highlight: function (element) {
        $(element).closest('.form-group').removeClass('has-success').addClass('has-error');
        $(element).closest('.form-group').removeClass('has-success').addClass('has-error');
      },
      unhighlight: function (element) {
        $(element).closest('.form-group').removeClass('has-error').addClass('has-success');
      },
      submitHandler: () => {
        if (!$('.form-group').hasClass('phone_validations')) {
          this.phone_bool = false;
        }
        setTimeout(() => {
          // if (this.phone_bool) {
          // this.otpsend();
          this.check_phone();
          // }
        }, 1000);
      }
    });

    $.validator.addMethod(
      'uniqueUserName',
      function () {
        if (telInput.intlTelInput('isValidNumber')) {
          return true;
        } else {
          return false;
        }
      },
      this.myacc.enterValidNum
    );
    const telInput = $('#changePhone'),
      errorMsg = $('#error-msg'),
      validMsg = $('#valid-msg');
    const reset = function () {
      telInput.removeClass('error');
      errorMsg.addClass('hide');
      validMsg.addClass('hide');
    };
    telInput.blur(function () {
      reset();
      if ($.trim(telInput.val())) {
        if (telInput.intlTelInput('isValidNumber')) {
          validMsg.removeClass('hide');
        } else {
          telInput.addClass('error');
          errorMsg.removeClass('hide');
        }
      }
    });

    $('.send_animate').click(function () {
      $('.send_animate').animate({ left: '-15px' }, 100).animate({ left: '15px' }, 100).animate({ left: '0px' }, 100);
    });
    $('#signup_inst').click(() => {
      if (!$('#signup_inst').hasClass('send_animate')) {
        // this.verify_otp();
        // this.otpsend();
        // this.check_phone();
        this.updateProfile(0);
      }
    });
    // $("#signup_inst").click(() => {
    //   if (!$("#signup_inst").hasClass('send_animate')) {
    //     this.otpsend();
    //   }
    // });
    $('#changePhone').keypress(function (event) {
      const $this = $(this);
      if ((event.which != 46 || $this.val().indexOf('.') != -1) &&
        ((event.which < 48 || event.which > 57) &&
          (event.which != 0 && event.which != 8))) {
        event.preventDefault();
      }

      const text = $(this).val();
      if ((event.which == 46) && (text.indexOf('.') == -1)) {
        setTimeout(function () {
          if ($this.val().substring($this.val().indexOf('.')).length > 3) {
            $this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
          }
        }, 1);
      }

      if ((text.indexOf('.') != -1) &&
        (text.substring(text.indexOf('.')).length > 2) &&
        (event.which != 0 && event.which != 8) &&
        ($(this)[0].selectionStart >= text.length - 2)) {
        event.preventDefault();
      }
    });
    $('.module input').keyup(function (e) {
      const code = e.keyCode || e.which;
      if ($(this).val().length > 0) {
        if ($(this).attr('id') === '4') {
          $('.one').css({ 'box-shadow': '0 0 10px #1EB2F7' });
          $('.one').css({ 'box-shadow': 'none' });
          $(this).blur();
          $('.send').removeClass('send_animate');
          $('.send').addClass('signup_inst');
        }
        if (code !== 4) {
          $(this).focusNextInputField();
        }
      } else {
        $('.send').addClass('send_animate');
        $('.send').removeClass('signup_inst');
        if ($(this).attr('id') !== '1') {
          $(this).focusPrevInputField();
        }
      }
    });

    $.fn.focusNextInputField = function () {
      return this.each(function () {
        const fields = $(this).parents('form:eq(0),body').find('button,input,textarea,select');
        const index = fields.index(this);
        if (index > -1 && (index + 1) < fields.length) {

          fields.eq(index + 1).focus();
        }
        return false;
      });
    };

    $.fn.focusPrevInputField = function () {
      return this.each(function () {
        const fields = $(this).parents('form:eq(0),body').find('button,input,textarea,select');
        const index = fields.index(this);
        if (index > -1 && (index - 1) < fields.length) {

          fields.eq(index - 1).focus();
        }
        return false;
      });
    };

    $('.modal').on('hidden.bs.modal', () => {
      this.current_password_block = false;
      this.change_password_block = true;
      $('#loader').hide();
    });
    jQuery('#back_button').show();
    this.current_time = new Date();
    this.current_time_var = this.current_time.getFullYear() + '-' + ('0' + (this.current_time.getMonth() + 1)).slice(-2) + '-' + this.current_time.getDate() + ' ' + this.current_time.getHours() + ':' + this.current_time.getMinutes() + ':' + this.current_time.getSeconds();

    $('#changePhone').intlTelInput({
      autoHideDialCode: true,
      geoIpLookup: function (callback) {
        $.get('https://ipapi.co/json/').always(function (res: any) {
          if (res.status >= 400 || res.error) {
            $.get('https://ipinfo.io', function () { }, 'jsonp').always(function (
              resp
            ) {
              console.log(resp);
              const countryCode = resp && resp.country ? resp.country : '';
              callback(countryCode);
            });
          } else {
            const countryCode = res && res.country ? res.country : '';
            callback(countryCode);
          }
        });
      },
      initialCountry: 'auto',
      nationalMode: true,
      separateDialCode: true,
      utilsScript:
        'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.4/js/utils.js'
    });

    // clear phone, email fields
    $('#confirmmail_phone').on('hidden.bs.modal', () => {
      $('#confirmmail_phone input').val('');
      this.phoneForm.resetForm();
      $('.phone_validations').removeClass('has-error');
      $('.wrap').animate({ left: '-625px', opacity: 0 }, 400);
      $('#confirmmail_form').animate({ left: '0px', opacity: 1 }, 400);
      setTimeout(function () {
        $('.confirmmail_head').show();
        $('#confirmmail_form').show();
        $('.wrap').hide();
        $('.wrap').animate({ left: '0px', opacity: 1 });
      }, 405);
    });
    $('#change_password_modal').on('hidden.bs.modal', () => {
      $('#change_password_modal input').val('');
      this.passwordForm.resetForm();
    });
  }

}

